import { writable } from 'svelte/store';
const filterState = () => {
    const { subscribe, set, update } = writable({});
    const reset = () => set({});
    const setState = (key, state) => update(x => (Object.assign(Object.assign({}, x), { [key]: state })));
    return {
        subscribe,
        reset,
        setState,
    };
};
export const filtered = filterState();
